import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../redux/hooks';
import { setSearchString } from '../redux/slices/questionsSlice';

/**
 * Custom hook that defines the functions to navigate to the other pages.
 * @returns An object containing the functions to navigate to other pages.
 */
const usePageLink = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  /**
   * Function to navigate to the home page with the specified tag as a search parameter.
   *
   * @param tagName - The name of the tag to be added to the search parameters.
   */
  const clickTag = (tagName: string) => {
    dispatch(setSearchString(`[${tagName}]`));
    const searchParams = new URLSearchParams();
    searchParams.set('tag', tagName);
    navigate(`/questions?${searchParams.toString()}`);
  };

  /**
   * Function to navigate to the specified question page based on the question ID.
   *
   * @param questionID - The ID of the question to navigate to.
   */
  const handleAnswer = (questionID: string) => {
    navigate(`/question/${questionID}`);
  };

  /**
   * Function to navigate to the profile page of the user with the given username.
   *
   * @param username - The username of the user whose page we are navigating to.
   */
  const handleUser = (username: string) => {
    navigate(`/profile/${username}`);
  };

  return { clickTag, handleAnswer, handleUser };
};

export default usePageLink;
